<template>
	<div class="">
		<div class="rightDist">
			<el-form label-position="right" label-width="100px">
				
	          <el-form-item label="权限：" >
	          	<el-radio-group v-model="distRight">
			      <el-radio v-for="(rightItem,index) in allRights" :label="rightItem.id" :key="rightItem.id">{{rightItem.group_name}}</el-radio>
			    </el-radio-group>
	          </el-form-item>
	          <el-form-item label="分组：">
			    <el-checkbox-group v-model="distGroups">
			      <el-checkbox v-for="(groupItem,index) in allGroups" :label="groupItem.packet_id" :key="groupItem.packet_id">{{groupItem.group_name}}</el-checkbox>
			    </el-checkbox-group>
			  </el-form-item>
			  <el-form-item label="分享账号：">
			    <el-checkbox-group v-model="distAccounts">
			      <el-checkbox v-for="(accountItem,index) in allAccounts" :label="accountItem.username" :key="accountItem.username">{{accountItem.real_name}}{{accountItem.username}}</el-checkbox>
			    </el-checkbox-group>
			  </el-form-item>
			  
	        </el-form>
	        <div class="text-center">
	        	<button class="btn btn-primary" @click="confirmDist()"> 确认分配 </button>
	        </div>
		</div>
		
	</div>
</template>
<script>
export default {
  data(){
    return {
    	allRights:[],
    	distRight:"",
    	allGroups:[],
    	distGroups:[],
    	allAccounts:[],
    	distAccounts:[]
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getGroupList();
    	this.getDevGroup();
    	this.getUserList();
  	})
  },

  methods: {
	//	获取权限分组列表
	getGroupList(){
		let groupListParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(groupListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/GroupList/GroupList",this.$qs.stringify(groupListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.allRights = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
//	获取设备分组列表
	getDevGroup(){
		let devGroupListParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(devGroupListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/Managementpacket/Managementpacket",this.$qs.stringify(devGroupListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.allGroups = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
	//	获取用户列表
	getUserList(){
		let userListParams={
			uid:this.getCookie('uid'),
	  		timestamp:Date.parse( new Date()),
	  		terminalId:4,
  			company_id:this.getCookie('company_id'),
  			page:1,
			pagesize:999,
  		};
  		this.sign(userListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/UserList/UserList",this.$qs.stringify(userListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1 && res.data.data){
        		this.allAccounts = res.data.data.name || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
//	权限分配
	confirmDist(){
		
		let distParams={
			uid:this.getCookie('uid'),
			auth_id:this.distRight,
			packet_id: JSON.stringify(this.distGroups).replace(/\[|]|"|"/g,''),
			share_username: JSON.stringify(this.distAccounts).replace(/\[|]|"|"/g,''),
	  		timestamp:Date.parse( new Date()),
	  		terminalId:4
  		};
  		this.sign(distParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/Authdistribution/Authdistribution",this.$qs.stringify(distParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.$message.success(res.data.msg);
		    	this.distRight="";
		    	this.distGroups=[];
		    	this.distAccounts=[];
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
	}
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/rigthsDistribute.vue